import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//import { IMAGEPATH } from "../../constant/constant";
import specialtyIcon from "../../styles/images/specialty-icon-blk.png";
import countryIcon from "../../styles/images/country-icon-blk.png";
import stateIcon from "../../styles/images/state-icon-blk.png";
import cityIcon from "../../styles/images/city-icon-blk.png";
import zipIcon from "../../styles/images/zip-icon.png"; 
import organizationIcon from "../../styles/images/organization-icon.png"; 
import DownloadPDF from "../pdf/DownloadPDF";
import NetworkSearchItem from "./NetworkSearchItem";
import { t } from "i18next";

const NetworkSearchInfo = ({ providerData, isProviderNetworkSearch }) => {
  const { countriesData, statesData, citiesData, specialitiesData } =
    useSelector((state) => state.formField);

  const getSelectedValue = (list, value) => {
    return list.find((item) => item.id === value);
  };

const [infoLabels, setInfoLabels] = useState({
  countrySearch: t("country-placeholder"),
  stateSearch: t("state-province-placeholder"),
  citySearch: t("city-placeholder"),
  specialitySearch: t("speciality-placeholder"),
});

  useEffect(() => {
    const updateInfoLabel = (data, dataList, placeholder) => {
      if (dataList.length > 0 && data) {
        const selectedValue = getSelectedValue(dataList, data);
        return selectedValue ? selectedValue.name : placeholder;
      } else {
        return placeholder;
      }
    };

    const selectedCountry = updateInfoLabel(
      providerData.countrySearch,
      countriesData,
      t("country-placeholder")
    );

    const selectedState = updateInfoLabel(
      providerData.stateSearch,
      statesData,
      t("state-province-placeholder")
    );

    const selectedCity = updateInfoLabel(
      providerData.citySearch,
      citiesData,
      t("city-placeholder")
    );

    const selectedSpeciality = updateInfoLabel(
      providerData.specialitySearch,
      specialitiesData,
      t("speciality-placeholder")
    );

    setInfoLabels((prevLabels) => ({
      ...prevLabels,
      countrySearch: selectedCountry,
      stateSearch: selectedState,
      citySearch: selectedCity,
      specialitySearch: selectedSpeciality,
    }));
  }, [providerData, countriesData, statesData, citiesData, specialitiesData]);

  return (
    <div className="container-fluid provider-search-container">
      <DownloadPDF
        providerData={providerData}
        isProviderNetworkSearch={isProviderNetworkSearch}
      />
      <div className="argusnetwork-filter top-20">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <ul className="list-inline">
              {isProviderNetworkSearch ? (
                <NetworkSearchItem
                  iconSrc={specialtyIcon}
                  altText="Speciality"
                  displayText={infoLabels.specialitySearch}
                />
              ) : (
                <>
                  <NetworkSearchItem
                    iconSrc={countryIcon}
                    altText="country Icon"
                    displayText={infoLabels.countrySearch}
                  />
                  <NetworkSearchItem
                    iconSrc={stateIcon}
                    altText="state Icon"
                    displayText={infoLabels.stateSearch}
                  />
                  <NetworkSearchItem
                    iconSrc={cityIcon}
                    altText="city Icon"
                    displayText={infoLabels.citySearch}
                  />
                  {providerData.zipSearch && (
                    <NetworkSearchItem
                      iconSrc={zipIcon}
                      altText="zip"
                      displayText={providerData.zipSearch}
                    />
                  )}
                  {providerData.organizationSearch && (
                    <NetworkSearchItem
                      iconSrc={organizationIcon}
                      altText="organizationSearch"
                      displayText={providerData.organizationSearch}
                    />
                  )}
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

NetworkSearchInfo.propTypes = {
  providerData: PropTypes.object.isRequired,
  isProviderNetworkSearch: PropTypes.bool.isRequired,
};

export default NetworkSearchInfo;
